<template>
    <div>
        <vue-element-loading :active="show" spinner="ring" color="#006db3" size="128" text="กรุณารอสักครู่..." is-full-screen/>
        <!-- <h1><i class="text-black-50 fa fa-cogs" aria-hidden="true"></i> จัดการฟอร์ม</h1> -->
        <NavBar></NavBar>
        <div class="container">
            <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12">
                    <button type="button" class="btn btn-light btn-lg pull-right" @click="openModal('สร้าง')">
                        <i class="fa fa-plus-circle fa-lg text-success" aria-hidden="true"></i> สร้าง Line Channel
                    </button>
                </div>
            </div>

            <table class="table table-hover mt-2" style="background-color: #fff;">
                <thead>
                    <tr>
                        <th v-for="(item, index) in thead" :key="index" scope="col" :class="item.class" :style="item.style">{{ item.name }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in tbody" :key="index">
                        <th scope="row" >{{ index+1 }}</th>
                        <td class="text-right">{{ item.id }}</td>
                        <td :title="item.channel_token">{{ item.channel_token }}</td>
                        <td >{{ item.form_id }}</td>
                        <td >{{ item.userCreate }}</td>
                        <td >{{ item.updated_at }}</td>
                        <td class="text-center">
                            <button type="button" class="btn btn-light mr-2" title="ลบ" @click="validatedCancelLineChannel(item)"><i class="fa fa-trash fa-lg text-danger" aria-hidden="true"></i></button>
                            <button type="button" class="btn btn-light" title="แก้ไข" @click="edit(item)"><i class="fa fa-pencil fa-lg text-primary" aria-hidden="true"></i></button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <ModalCenter :open="isOpen" :title="title+' Line channel token'" :styleModalHeader="{'background': '#fefefe', 'color': '#212529'}" @close="closeModal">
            <template v-slot:content>
                <form :class="validated ? 'was-validated':''">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12">
                            <label class="mb-0">Line channel token</label>
                            <textarea type="text" :class="'form-control textarea-description pb-0 '+(validated ? 'was-validated':'')" v-model="channelToken" @focus="onFocus" placeholder="Line channel token" required></textarea>
                            <div class="invalid-feedback m-0">กรุณากรอกข้อมูล</div>
                        </div>
                    </div>
                    <div class="row mt-2 mb-2">
                        <div class="col-xl-12 col-lg-12 col-md-12">
                            <label for="form" class="mb-0">เลือกฟอร์ม</label>
                            <select id="form" :class="'form-control '+(validated ? 'was-validated':'')" v-model="formId" required>
                                <option value="" disabled class="text-black-50">กรุณาเลือกฟอร์ม</option>
                                <option v-for="(item,index) in listForm" :key="index" :value="item.id">{{ item.name }}</option>
                            </select>
                            <div class="invalid-feedback m-0">กรุณากรอกข้อมูล</div>
                        </div>
                    </div>
                </form>
            </template>
            <template v-slot:footer>
                <button type="button" class="btn btn-success" @click="validatedLineChannel">{{ title }}</button>
            </template>
        </ModalCenter>

    </div>
</template>

<script>
import Vue from 'vue';
import Api from './../api';

import NavBar from '@/components/NavBar';
import ModalCenter from '@/components/ModalCenter';
export default {
    components:{
        NavBar,
        ModalCenter
    },

    data(){
        return {
            user: null,
            show: false,
            validated: false,
            thead: [
                { name: '#', style:{ width: '2%' } },
                { name: 'รหัส Line channel', style:{ width: '10%' } },
                { name: 'Line channel token', style:{ width: '12%' }  },
                { name: 'ชื่อฟรอ์ม', style:{ width: '10%' } },
                { name: 'ผู้สร้าง', style:{ width: '10%' } },
                { name: 'วันที่แก้ไขล่าสุด', style:{ width: '16%' } },
                { name: 'จัดการ', class: 'text-center', style:{ width: '8%' } },
            ],
            tbody: [],

            isOpen: false,
            title: '',
            lineChannelId: '',
            channelToken: '',
            formId: '',
            listForm: [],

        }
    },

    created(){
        this.user = this.$store.state.user;
        this.getLineChannelActiveAll();
        this.getFormActiveAll();
    },

    watch: {

    },

    methods:{
        onFocus(event) {
            event.target.select();
        },

        getFormActiveAll(){
            this.show = true;
            this.listForm = [];
            Api.getFormActiveAll().then(res => {
                this.show = false;
                var {data} = res;
                if(data.result){
                    this.listForm = data.result;
                }else{
                    this.$swal(data.message, '', "warning");
                }
            }).catch(err => {
                this.show = false;
                this.$swal('เกิดข้อผิดพลาด!', 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์', "error");
            })
        },

        getLineChannelActiveAll(){
            this.show = true;
            Api.getLineChannelActiveAll().then(res => {
                this.show = false;
                var {data} = res;
                if(data.result){
                    this.tbody = data.result.map(it=> {
                        if(it.user_id==this.user.userId){
                            Vue.set(it, 'userCreate', 'ตัวเอง');
                        }else{
                            Vue.set(it, 'userCreate', it.user.name);
                        }

                        Vue.set(it, 'updated_at', this.$moment(it.updated_at).format('LLL'))
                        return it
                    })
                }else{
                    this.$swal(data.message, '', "warning");
                }
            }).catch(err => {
                this.show = false;
                this.$swal('เกิดข้อผิดพลาด!', 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์', "error");
            })
        },

        intialValue(){
            this.lineChannelId = "";
            this.title = "";
            this.channelToken = "";
            this.formId = "";
        },

        edit(obj){
            this.lineChannelId = obj.id;
            this.channelToken = obj.channel_token;
            this.formId = obj.form_id;
            this.openModal('แก้ไข');
        },

        openModal(title) { 
            this.isOpen = true;
            this.title = title;
        },

        closeModal() {
            this.isOpen = false;
            this.intialValue();
        },

        validatedLineChannel(){
            this.validated = true;
            if(this.channelToken!='' && this.formId!=''){
                if(this.title=='สร้าง'){
                    this.saveLineChannel();
                }else if(this.title=='แก้ไข'){
                    this.updateLineChannel();
                }
            }else{
                this.$swal('กรุณากรอกข้อมูล!', '', "warning");
            }
        },

        saveLineChannel(){
            this.show = true;
            var token = this.user.token;
            var body = {
                channelToken: this.channelToken,
                formId: this.formId
            };
            Api.saveLineChannel(token,body).then(res => {
                this.show = false;
                var {data} = res;
                if(data.result){
                    this.$swal(data.message, '', "success");
                    this.closeModal();
                    this.getLineChannelActiveAll();
                }else{
                    this.$swal(data.message, '', "warning");
                }
            }).catch(err => {
                this.show = false;
                this.$swal('เกิดข้อผิดพลาด!', 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์', "error");
            })
        },

        updateLineChannel(){
            this.show = true;
            var token = this.user.token;
            var body = {
                id: this.lineChannelId,
                channelToken: this.channelToken,
                formId: this.formId
            };
            Api.updateLineChannel(token,body).then(res => {
                this.show = false;
                var {data} = res;
                if(data.result){
                    this.$swal(data.message, '', "success");
                    this.closeModal();
                    this.getLineChannelActiveAll();
                }else{
                    this.$swal(data.message, '', "warning");
                }
            }).catch(err => {
                this.show = false;
                this.$swal('เกิดข้อผิดพลาด!', 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์', "error");
            })
        },

        validatedCancelLineChannel(obj){
            this.$swal({
                title: 'ต้องการลบรหัส Line channel '+obj.id,
                text: "ตรวจสอบข้อมูลให้แน่ใจก่อนยืนยัน",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ยืนยัน',
                cancelButtonText: 'ยกเลิก'
                }).then((result) => {
                if (result.isConfirmed) {
                    this.cancelLineChannel(obj);
                }
            })
        },

        cancelLineChannel(obj){
            this.show = true;
            var token = this.user.token;
            var body = {
                id: obj.id,
            };
            Api.cancelLineChannel(token,body).then(res => {
                this.show = false;
                var {data} = res;
                if(data.result){
                    this.$swal(data.message, '', "success");
                    this.getLineChannelActiveAll();
                }else{
                    this.$swal(data.message, '', "warning");
                }
            }).catch(err => {
                this.show = false;
                this.$swal('เกิดข้อผิดพลาด!', 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์', "error");
            })
        },
    }
}
</script>

<style scoped>
    #create-form {
        border: 1px solid rgba(0, 0, 0, 0.125);
    }

    td.ellipsis {
        white-space: nowrap; 
        width: 5px; 
        overflow: hidden;
        text-overflow: ellipsis; 
    }

    table {
        table-layout: fixed;
        width: 100%;
    }
    td {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

</style>